/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * One stage of the MCP server probe, in the order it runs.
 */
export enum DiagnosticStep {
    ADDRESS = 'address',
    REACHABLE = 'reachable',
    CHALLENGE = 'challenge',
    RESOURCE_METADATA = 'resource_metadata',
    AUTH_SERVER_METADATA = 'auth_server_metadata',
    CLIENT_REGISTRATION = 'client_registration',
}
